export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ09.09ff9a8c.mp3";